app.controller('appealsController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $modal, $anchorScroll, $controller, anchorSmoothScroll) {
	//Include custom controller functionality
	$controller('userDefinedAppealsController', {$scope: $scope});

	$scope.files={};
	$scope.extension_error={};
	$scope.extension_label={};

	$scope.getFiles = function()
	{
		return $scope.files;
	}

	$scope.extensionError = function()
	{
		return $scope.extension_error;
	}

	$scope.extensionsLabel = function()
	{
		return $scope.extension_label;
	}

	$scope.fileSizeError = function()
	{
		return $scope.file_size_error;
	}


	$scope.imageUpload = function(event){

		if(event.target.value == null || event.target.value == '')
        {
        	return false;
        }

		/** extension checking **/
        var allowed_extension = [];
        var extension_label = [];
        var extension = [];
        var attrs = event.target;
        var newFileList = [];
        var extension_error = [];

        if(typeof(attrs.getAttribute("allowed-extension")) != 'undefined')
        {
            if(attrs.getAttribute("allowed-extension") != '')
            {
                allowed_extension = JSON.parse(attrs.getAttribute("allowed-extension"));
                angular.forEach(allowed_extension, function(element, key) {
                  extension.push(element);
                  extension_label.push(key);
                });
            }
        }

        var files = event.target.files;
        if(typeof($scope.fileList) != 'undefined' && $scope.fileList.length > 0)
        {
        	var newFileList = $scope.fileList;
        	angular.forEach(files, function(element, key) {
              newFileList.push(element);
            });
        }
        else
        {
        	angular.forEach(files, function(element, key) {
              newFileList.push(element);
            });
        }


        if(typeof(attrs.getAttribute("max-num-files-allowed")) != 'undefined')
        {
            if(attrs.getAttribute("max-num-files-allowed") > 0)
            {
                var allowed_limit = attrs.getAttribute("max-num-files-allowed");
                
                if(typeof(newFileList) != 'undefined' && newFileList.length > allowed_limit)
                {
                	var diff = newFileList.length - allowed_limit;
                	for(var i=0; i < diff; i++)
                	{
                		newFileList.pop();
                	}
                	$scope.openInfoPopUp('Maximum of '+allowed_limit+' documents allowed', 'danger');
                    //alert('Maximum of '+allowed_limit+' documents allowed');
                    //return false;
                }
            }
        }
        
        
        var slicedList = [];
        for (var i = 0; i < newFileList.length; i++) {
            if(extension.length > 0)
            {
                if(extension.indexOf(newFileList[i].type) == -1)
                {
                	var removed_name = newFileList[i].name;
                    //sliceList.splice(i,1);
                    extension_error.push(removed_name+' is not allowed.');
                }
                else
                {
                	slicedList.push(newFileList[i]);
                }
            }
        }
		newFileList = slicedList;

        /** file size checking **/
        var file_size_error = [];
        var sizedList = [];
        if(typeof(attrs.getAttribute("allowed-max-size")) != 'undefined')
        {
            if(attrs.getAttribute("allowed-max-size") > 0)
            {
                allowed_size = attrs.getAttribute("allowed-max-size");
                
                for (var i = 0; i < newFileList.length; i++) {
                    var size = newFileList[i]['size']/1024;
                    if(size > allowed_size)
                    {
                    	var removed_name = newFileList[i].name;
                        file_size_error.push(removed_name+' is not allowed.');
                    }
                    else
                    {
                    	sizedList.push(newFileList[i]);
                    }
                }

            }
        }
		newFileList = sizedList;

        $scope.extension_label = extension_label;
        $scope.extension_error = extension_error;
        $scope.file_size_error = file_size_error;
        $scope.fileList = newFileList;
		$scope.files = newFileList;
		event.target.value = '';
	}

	$scope.deleteFile = function(idx) {
		var files = $scope.files;
		var newFileList = [];
		angular.forEach(files, function(element, key) {
          newFileList.push(element);
        });
		newFileList.splice(idx,1);
		$scope.files = newFileList;
		$scope.fileList = newFileList;
		$('#file_selected_'+idx).remove();
	}

	$scope.openInfoPopUp = function(message, type, title) {
		type = typeof(type) != 'undefined' ? type : 'success';
		title = typeof(title) != 'undefined' ? title : 'Appeals';
        var modalInstance = $modal.open({
            templateUrl: 'views/info_modal.html',
            controller: function($scope, $modalInstance){
            	$scope.info_popup_message = message;
            	$scope.info_popup_type = type;
            	$scope.info_popup_title = title;
            	$scope.ok = function() {
            		$scope.info_popup_message = '';
            		$scope.info_popup_type = '';
            		$scope.info_popup_title = '';
			        $modalInstance.close();
			    };

			    $scope.cancel = function() {
            		$scope.info_popup_message = '';
            		$scope.info_popup_type = '';
            		$scope.info_popup_title = '';
			        $modalInstance.dismiss('cancel');
			    };
            }
        });
    };
	
	$scope.update = function(url) 
    {
		//validate if comment is null
		var comment = $.trim($("#appeal_comment").val());
		var appeal_category = $.trim($("#appeal_category").val());
		var appeal_type = $.trim($("#appeal_type").val());
		var appeal_status = $.trim($("#appeal_status").val());
		var verify = $('input[name="verify"]:checked').length > 0;
		var email_address = $('#appeal_email').val();
		var appeal_unique_id = $('#appeal_unique_id').val();
		var min_num_files = $('#appeal_file_uploader').attr('min-num-files-allowed');

		if(appeal_unique_id > 0)
		{
			verify = true;
		}

		if(typeof($scope.$parent.minNumFilesAllowed) != 'undefined' && typeof(min_num_files) != 'undefined')
		{
			if(typeof($scope.files.length) == 'undefined' || $scope.files.length < $scope.$parent.minNumFilesAllowed)
			{
				$scope.openInfoPopUp('Minimum of '+$scope.$parent.minNumFilesAllowed+' document required','danger');
				//alert('Minimum of '+$scope.$parent.minNumFilesAllowed+' document required');
				return false;
			}
		}

		$('.appeal_error_message').removeClass('alert-danger alert-success alert-info').html('').hide();
		$('.appeal_verify_error_message').removeClass('alert-danger alert-success alert-info').html('').hide();
		
		if(comment != '' && verify === true)
		{
			if(typeof($scope.google_analytics_tracking_code) != 'undefined' && $scope.google_analytics_tracking_code != '')
			{
				var submenu_label = $scope.appState.submenu_key;
				if(typeof($scope.submenu_labels) != 'undefined' && typeof($scope.submenu_labels[$scope.appState.submenu_key]) != 'undefined')
				{
					submenu_label = $scope.submenu_labels[$scope.appState.submenu_key].toLowerCase();
				}
				gtag('event', $scope.appState.page+'_'+submenu_label+'_appeal', {'event_category': $scope.appState.page+'_appeal', 'event_label': 'Appeal'});
			}

			//Add comment
			var url = url;
			
			var post_data = angular.copy($scope.pageState);
			post_data['app_state']     = $scope.appState;
			post_data['page_mode']     = 'update';
			post_data['comment']       = comment;
			post_data['appeal_type']   = appeal_type;
			post_data['category']      = appeal_category;
			post_data['status']        = appeal_status;
			post_data['verify']    	   = verify;
			post_data['appeal_email']  = email_address;

			$('.appeal_processing_spinner').show();
			$('.appeal_submit_form .appeal_form_container').hide();

			dataService.getDataWithFileUpload(url, post_data , 'POST', $scope.files, null, null, null, $scope)
				.then(function(response) {
					
					//hide loading
					$('.appeal_processing_spinner').hide();
					$('.appeal_error_message').hide();
					$('.appeal_verify_error_message').hide();

					$('.appeal_submit_form .appeal_form_container').show();

					if(typeof(response.data) != 'undefined')
					{	
						if(typeof(response.data.appeal) != 'undefined' && typeof(response.data.appeal.id) != 'undefined')
						{
							if(typeof(response.data.upload_error) != 'undefined' && response.data.upload_error.length > 0)
							{
								var upload_err_msg = '<span style="color:green">Appeal Updated.</span><br/><br/>But some of the specified files were not uploaded.<br/>';
								angular.forEach(response.data.upload_error, function(err_msg, key) {
								  upload_err_msg += err_msg+'<br/>'; 
								});
								$scope.openInfoPopUp(upload_err_msg,'danger');
								/*$('.appeal_error_message').addClass('alert-danger').html(upload_err_msg);
								$('.appeal_error_message').show();*/
							} else {
								//show status
								//$('.appeal_error_message').addClass('alert-success').html(response.message);
								//$('.appeal_error_message').show();
							
							}

							//update scope
							var componentKey = $scope.componentKey;
							if(typeof(response.data.appeal.status) != 'undefined')
							{
      							$scope.openInfoPopUp('<strong>Appeal updated successfully</strong>');

								/*$('.appeal_success_message').show();
								$('.appeal_success_message').html('Appeals updated successfully');*/
								$('#appeal_submit_form')[0].reset();

								/*setTimeout(function() {
								    $('.appeal_success_message').fadeOut('slow');
								}, 5000);*/

								//removing all the uploaded files.
								angular.forEach(angular.element("input[type='file']"), function(inputElem) {
      								angular.element(inputElem).val(null);
      								angular.element(inputElem).scope().files = null;
    							});

    							$scope.files = null;
    							$scope.fileList = [];
    							$scope.appealDocuments = (typeof(response.data.uploads) != 'undefined') ? response.data.uploads : null;
    							$scope.appealComments = (typeof(response.data.comments) != 'undefined') ? response.data.comments : null;
								//$scope.$parent.showAppealForm = false;
								if(typeof($scope.$parent.$parent[componentKey].selectedRowData.additional.app_metric_appeal_status) != 'undefined' )
								{
									$scope.$parent.$parent[componentKey].selectedRowData.additional.app_metric_appeal_status.value = response.data.appeal.status;
								}
								$scope.appealStatus = response.data.appeal.status;
								$scope.appealDetails = response.data.appeal;
								$scope.$parent.$parent[componentKey].selectedRowData.appeal_details.appeal = response.data.appeal;
								$scope.$parent.$parent.pageState.appealId = response.data.appeal.id;

								//$($scope.$parent.$parent[componentKey].selectedRow).find('td:eq(8)').html($scope.appealStatus);
								$($scope.$parent.$parent[componentKey].selectedRow).find('.appeals').html(response.data.appeal.status_label.toUpperCase());
								//update survey summary table row to reflect the change
								//var status_class = $scope.$parent.$parent.displayAlertClass(response.data.appeal.status);
								//$($scope.$parent.$parent[componentKey].selectedRow).find('td:eq(0) i:eq(0)').removeClass('hot_alert_open hot_alert_inprogress').addClass('hot_alert_' + status_class);
								
							}

						}
						else
						{
							$scope.openInfoPopUp(response.message,'danger');
                            /*$('.appeal_error_message').addClass('alert-danger').html(response.message);
                            $('.appeal_error_message').show();*/
						}	
					}
					else {
						$scope.openInfoPopUp('Unexpected Error: Unable to update, please try again.','danger');
                        /*$('.appeal_error_message').addClass('alert-danger').html('Unexpected Error: Unable to update, please try again.');
                        $('.appeal_error_message').show();*/

       				}
				}
			);
		}
		else
		{
			if(comment == '')
			{
				$('.appeal_error_message').addClass('alert-danger').html('Comment cannot be empty');
				$('.appeal_error_message').show();
				$('#div_appeal_form #appeal_comment').addClass('error');
			}
			
			if(verify === false)
			{
				$('.appeal_verify_error_message').addClass('alert-danger').html('Please check the below checkbox and proceed.');
				$('.appeal_verify_error_message').show();
				$('#div_appeal_form #verify').addClass('error');
			}
		}	
		
        //$modalInstance.close();
    };
	
	$scope.cancel = function() {
		$scope.fileList = [];
		$('#appeal_submit_form')[0].reset();
		$('.panel .panel-heading .actions .fa-chevron-up').click();
    };
	
})
